module.exports = __webpack_public_path__ + "img/patent_5.a78fbfd.jpg";